export default "__VITE_ASSET__DKqG2x5z__"